/* MASTOC — apparitions au défilement + guide interactif */
(function () {
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.mx-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function initGuide(root) {
    (root || document).querySelectorAll('[data-mx-guide]').forEach(function (guide) {
      if (guide.dataset.ready) return;
      guide.dataset.ready = '1';
      var tabs = guide.querySelectorAll('[role="tab"]');
      var panels = guide.querySelectorAll('[role="tabpanel"]');
      function select(tab) {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); t.tabIndex = t === tab ? 0 : -1; });
        panels.forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (next) { e.preventDefault(); next.focus(); select(next); }
        });
      });
    });
  }

  function init(root) { initReveal(root); initGuide(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Éditeur de thème Shopify : réinitialiser quand une section est rechargée */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    e.target.querySelectorAll('.mx-reveal').forEach(function (el) { el.classList.add('is-visible'); });
  });
})();

/* Ferme le menu mobile apres un clic sur une ancre */
document.addEventListener('click', function (e) { var a = e.target.closest('#menu-drawer a[href*="#"]'); var hd = document.querySelector('header-drawer'); if (a && hd && hd.closeMenuDrawer) { var s = hd.querySelector('summary'); hd.closeMenuDrawer(e, s); s.setAttribute('aria-expanded', 'false'); } });
/* Retient le coffret choisi dans l'inscription */
document.addEventListener('click', function (e) { var p = e.target.closest('[data-coffret]'); if (!p) return; document.querySelectorAll('input[name="contact[tags]"]').forEach(function (i) { i.value = 'newsletter,lancement-mastoc,' + p.dataset.coffret; }); document.querySelectorAll('form[id^="mx-"]').forEach(function (f) { var m = f.querySelector('.mx-choice'); if (!m) { m = document.createElement('p'); m.className = 'mx-choice'; f.prepend(m); } m.textContent = 'Vous serez prévenu pour : ' + p.dataset.coffretName; }); });
